"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sayHello = void 0;
var Utils_1 = require("./Utils");
var BuildInfo = require("./version");
function sayHello() {
    var hello = "%c" + BuildInfo.PACKAGE_NAME + " v" + BuildInfo.PACKAGE_VERSION;
    if (BuildInfo.GIT_BRANCH !== undefined) {
        hello += " - " + BuildInfo.GIT_BRANCH;
        if (BuildInfo.GIT_COMMIT !== undefined) {
            hello += "#" + BuildInfo.GIT_COMMIT.substr(0, 7);
        }
    }
    hello += " - %chttps://reli.sh";
    console.log(hello, Utils_1.LogUtils.STYLE_BLACK, Utils_1.LogUtils.STYLE_RELISH_BOLD);
}
exports.sayHello = sayHello;
//# sourceMappingURL=hello.js.map